import React, { useEffect } from 'react';
import { ManIcon, GreenMarker, YellowMarker, RedMarker } from '../assets';
import { GoogleMap, useGoogleMap } from './GoogleMap';
import SimpleTable from './../components/SimpleTable';

const Position = ({ coordinates, markerColor, mData, unClearedAlarms }) => {
  return (
    <>
      <GoogleMap.Marker
        position={coordinates}
        icon={
          markerColor === 'green'
            ? GreenMarker
            : markerColor === 'yellow'
            ? YellowMarker
            : RedMarker
        }>
        {/* <h4>Vehicle# {vehilceNo}</h4>
        <p>Type: {vehicleType}</p> */}
        <SimpleTable mData={mData} unClearedAlarms={unClearedAlarms} />
      </GoogleMap.Marker>
      {/* <GoogleMap.Circle center={position} radius={50} /> */}
    </>
  );
};

const EquipmentMarkers = ({
  coordinates,
  markerColor,
  mData,
  unClearedAlarms,
}) => {
  const { map } = useGoogleMap();
  // console.log(mData);
  if (!markerColor) {
    markerColor = 'green';
  }
  useEffect(() => {
    setTimeout(() => {
      map?.panTo(coordinates);
    }, 500);
    setTimeout(() => {
      map?.panTo(coordinates);
    }, 1000);
  }, []);

  // let renderMap = {
  //   green: <GreenPosition position={coordinates} />,
  //   yellow: <YellowPosition position={coordinates} />,
  //   red: <RedPosition position={coordinates} />,
  // };

  // renderMap = renderMap[markerColor];

  return (
    <Position
      coordinates={coordinates}
      markerColor={markerColor}
      mData={mData}
      unClearedAlarms={unClearedAlarms}
    />
  );
};

export default EquipmentMarkers;
